import { defineMessages } from "react-intl"
import { SelectOption } from "../../common/types"
import { PAYMENT_3DS_STATUS, PAYMENT_SOURCE, PAYMENT_STATUS } from "../../state/helpers/Payment"

export const getPaymentStatusOptions = (intlService) : SelectOption<string>[] => {

    const messages = defineMessages({
        [PAYMENT_STATUS.PENDING]: {
            id: "payment.payment_status_select.pending",
            defaultMessage: "Pending",
        },
        [PAYMENT_STATUS.CAPTURED]: {
            id: "payment.payment_status_select.captured",
            defaultMessage: "Captured",
        },
        [PAYMENT_STATUS.DECLINED]: {
            id: "payment.payment_status_select.declined",
            defaultMessage: "Declined",
        },
        [PAYMENT_STATUS.EXPIRED]: {
            id: "payment.payment_status_select.expired",
            defaultMessage: "Expired",
        },
        [PAYMENT_STATUS.CANCELED]: {
            id: "payment.payment_status_select.canceled",
            defaultMessage: "Canceled",
        },
    })
    
    return [
        {
            value: PAYMENT_STATUS.PENDING,
            label: intlService.formatMessage(messages[PAYMENT_STATUS.PENDING]),
        },
        {
            value: PAYMENT_STATUS.CAPTURED,
            label: intlService.formatMessage(messages[PAYMENT_STATUS.CAPTURED]),
        },
        {
            value: PAYMENT_STATUS.DECLINED,
            label: intlService.formatMessage(messages[PAYMENT_STATUS.DECLINED]),
        },
        {
            value: PAYMENT_STATUS.EXPIRED,
            label: intlService.formatMessage(messages[PAYMENT_STATUS.EXPIRED]),
        },
        {
            value: PAYMENT_STATUS.CANCELED,
            label: intlService.formatMessage(messages[PAYMENT_STATUS.CANCELED]),
        },
    ]
}

export const getPayment3DSStatusOptions = (intlService) : SelectOption<string>[] => {
    const messages = defineMessages({
        [PAYMENT_3DS_STATUS.SUCCEEDED]: {
            id: "payment.payment_3ds_status_select.succeeded",
            defaultMessage: "Succeeded",
        },
        [PAYMENT_3DS_STATUS.FAILED]: {
            id: "payment.payment_3ds_status_select.failed",
            defaultMessage: "Failed",
        },
    })
    
    return [
        {
            value: PAYMENT_3DS_STATUS.SUCCEEDED,
            label: intlService.formatMessage(messages[PAYMENT_3DS_STATUS.SUCCEEDED]),
        },
        {
            value: PAYMENT_3DS_STATUS.FAILED,
            label: intlService.formatMessage(messages[PAYMENT_3DS_STATUS.FAILED]),
        },
    ]
}

export const getPaymentSourceOptions = (intlService) : SelectOption<string>[] => {
    const messages = defineMessages({
        [PAYMENT_SOURCE.ONLINE]: {
            id: "payment.payment_source_select.online",
            defaultMessage: "Online",
        },
        [PAYMENT_SOURCE.BACKOFFICE]: {
            id: "payment.payment_source_select.back_office",
            defaultMessage: "Back office",
        },
        [PAYMENT_SOURCE.RECURRING]: {
            id: "payment.payment_source_select.recurring",
            defaultMessage: "Recurring",
        },
    })

    return [
        {
            value: PAYMENT_SOURCE.ONLINE,
            label: intlService.formatMessage(messages[PAYMENT_SOURCE.ONLINE]),
        },
        {
            value: PAYMENT_SOURCE.BACKOFFICE,
            label: intlService.formatMessage(messages[PAYMENT_SOURCE.BACKOFFICE]),
        },
        {
            value: PAYMENT_SOURCE.RECURRING,
            label: intlService.formatMessage(messages[PAYMENT_SOURCE.RECURRING]),
        },
    ]
}



// WEBPACK FOOTER //
// ./src/payment/components/utils.ts